(function ($, window, document, undefined) {
	'use strict';

	var methods = {
		init: function (options) {
			options = $.extend({
				onOpen: function () {
				},
				onClose: function () {
				}
			}, options);

			options.class = $.extend({
				drawer: 'drawer',
				opened: 'drawer--opened',
				section: 'drawer__section',
				sectionNext: 'drawer__section--next',
				sectionPrev: 'drawer__section--prev',
				sectionLink: 'js-drawer-menu__section-link',
				close: 'js-drawer__close',
				back: 'js-drawer__back'
			}, options.class);

			var i = 0;
			return this.each(function () {
				var $drawer = $(this),
					_this = this,
					data = $drawer.data('drawer');

				$drawer.find('.' + options.class.close).on('click.drawer', function () {
					methods.close.call($drawer);
				});

				$drawer.find('.' + options.class.sectionLink).on('click.drawer', function (event) {
					event.preventDefault();

					var $link = $(this),
						section = $link.data('drawerSectionLink');

					if (section) {
						methods.nextSection.call($drawer, section);
					}
				});

				$drawer.find('.' + options.class.back).on('click.drawer', function () {
					methods.prevSection.call($drawer);
				});

				if (!data) {
					$drawer.data('drawer', {
						options: options,
						sectionStack: ['home'],
						index: i++
					});
				}
			});

		},

		destroy: function () {
			return this.each(function () {
				var $this = $(this),
					data = $this.data('drawer');

				$this.find('.' + data.options.class.close).off('click.drawer');
			});
		},

		open: function () {
			return this.each(function () {
				var $this = $(this),
					_this = this,
					data = $this.data('drawer');

				$this.addClass(data.options.class.opened);
				if (data.options.onOpen)
					data.options.onOpen.call(_this);
			});
		},

		close: function () {
			return this.each(function () {
				var $this = $(this),
					_this = this,
					data = $this.data('drawer');

				$this.removeClass(data.options.class.opened);
				if (data.options.onClose)
					data.options.onClose.call(_this);
			});
		},

		toggle: function () {

		},

		nextSection: function (section) {
			return this.each(function () {
				var $this = $(this),
					_this = this,
					data = $this.data('drawer'),
					curSection = data.sectionStack[data.sectionStack.length - 1],
					$curSection = $this.find('.' + data.options.class.section + "[data-drawer-section='" + curSection + "']"),
					$nextSection = $this.find('.' + data.options.class.section + "[data-drawer-section='" + section + "']");

				$curSection.addClass('drawer__section--prev');
				$nextSection.removeClass('drawer__section--next');
				data.sectionStack.push(section);
				$this.data('drawer', data);
			});
		},

		prevSection: function () {
			return this.each(function () {
				var $this = $(this),
					data = $this.data('drawer');

				if (data.sectionStack.length <= 1) {
					return;
				}

				var curSection = data.sectionStack.pop(),
					prevSection = data.sectionStack[data.sectionStack.length - 1],
					$curSection = $this.find('.' + data.options.class.section + "[data-drawer-section='" + curSection + "']"),
					$prevSection = $this.find('.' + data.options.class.section + "[data-drawer-section='" + prevSection + "']");

				$curSection.addClass('drawer__section--next');
				$prevSection.removeClass('drawer__section--prev');
				$this.data('drawer', data);
			});
		}
	};

	$.fn.drawer = function (method) {
		if (methods[method]) {
			return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
		} else if (typeof method === 'object' || !method) {
			return methods.init.apply(this, arguments);
		} else {
			$.error('Method ' + method + ' does not exist on jQuery.');
		}

	};
})(jQuery, window, document);

